import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Counter from '../../components/Counter';
import Button from '../../components/Button';

import contactBG from '../../assets/img/contact/contact-bg-3-1.jpg';

const Contact = () => {
  const formRef = useRef();

  // Emailjs setup
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', formRef.current, {
        publicKey: 'YOUR_PUBLIC_KEY',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        }
      );
  };

  // Initialize counters array
  const counters = [
    {
      countNum: 137,
      countSubtext: '+',
      countTitle: 'Expert Doctors',
    },
    {
      countNum: 800,
      countSubtext: '+',
      countTitle: 'Happy Patients',
    },
    {
      countNum: 90,
      countSubtext: '+',
      countTitle: 'Health Departments',
    },
    {
      countNum: 50,
      countSubtext: '+',
      countTitle: 'Total Branches',
    },
  ];

  return (
    <div
      className="it-contact-area it-contact-overley it-contact-style-2 z-index pt-120 mb-165"
      style={{ backgroundImage: `url(${contactBG})` }}
    >
      <div id="it-contact" className="container">
        <div className="row align-items-end">
          <div className="col-xxl-5 col-xl-6 col-lg-6">
            <div className="it-contact-item">
              <h4 className="it-contact-title mb-60">
                Get support For any Queries or Complaints
              </h4>
              <div className="row">
                {counters.map((counter, index) => (
                  <div
                    key={index}
                    className="col-lg-6 col-md-4 col-6 col-sm-6 mb-10"
                  >
                    <div className="it-funfact-item">
                      <h5 className="it-funfact-number">
                        <Counter
                          start={0}
                          end={counter.countNum}
                          duration={3}
                          counterSubText={counter.countSubtext}
                        />
                      </h5>
                      <span className="it-funfact-title">
                        {counter.countTitle}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-xxl-7 col-xl-6 col-lg-6">
            <div className="it-contact-from-wrap z-index">
              <h4 className="it-contact-title text-black mb-10">
                Book An Appointment
              </h4>
              <div className="it-contact-text mb-40">
                <p>
                  Neque porro quisquam est, qui dolorem ipsum quia dolor sit
                  amet, consectetur, <br /> adipisci velit, sed quia non numquam
                  eius modi
                </p>
              </div>
              <form ref={formRef} onSubmit={handleSubmit}>
                <div className="row gx-20">
                  <div className="col-md-6 col-12 mb-20">
                    <div className="it-contact-input-box">
                      <input type="text" placeholder="Name" />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 mb-20">
                    <div className="it-contact-input-box">
                      <input type="email" placeholder="E-mail" />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 mb-20">
                    <div className="it-contact-input-box">
                      <input type="text" placeholder="Phone" />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 mb-20">
                    <div className="it-contact-input-box">
                      <input type="text" placeholder="Subject" />
                    </div>
                  </div>
                  <div className="col-12 mb-30">
                    <div className="it-contact-input-box">
                      <textarea placeholder="Comment"></textarea>
                    </div>
                  </div>
                </div>
                <button type="submit" className="it-btn-theme tertiary-bg">
                  <Button btnText="Submit now" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
